import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a4825ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "keycontent" }
const _hoisted_2 = { id: "keybord" }
const _hoisted_3 = { class: "top w-full flex items-center" }
const _hoisted_4 = { class: "flex-1 text-center" }
const _hoisted_5 = { class: "keyBox keyBoxTop" }
const _hoisted_6 = { class: "keyBox" }
const _hoisted_7 = { class: "keyBox" }
const _hoisted_8 = { class: "keyBox" }
const _hoisted_9 = { class: "keyBox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "keyStyle",
  "data-key": ".",
  "data-code": "110",
  style: {"background":"#EAEEF4"}
}, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "keyStyle",
  "data-key": "delete",
  "data-code": "46",
  style: {"background":"#EAEEF4"}
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_minus_outlined = _resolveComponent("minus-outlined")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_JIcon = _resolveComponent("JIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reduce(1))),
          style: {"cursor":"pointer"}
        }, [
          _createVNode(_component_minus_outlined, { class: "operateIcon" })
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.numberValue ? _ctx.numberValue : "0"), 1),
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add(1))),
          style: {"cursor":"pointer"}
        }, [
          _createVNode(_component_plus_outlined, { class: "operateIcon" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: "keyStyle",
          "data-key": "1",
          "data-code": "49",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clickNum(1)))
        }, "1 "),
        _createElementVNode("div", {
          class: "keyStyle mx-6",
          "data-key": "2",
          "data-code": "50",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clickNum(2)))
        }, "2"),
        _createElementVNode("div", {
          class: "keyStyle",
          "data-key": "3",
          "data-code": "51",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.clickNum(3)))
        }, "3")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("li", {
          class: "keyStyle",
          "data-key": "4",
          "data-code": "52",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clickNum(4)))
        }, "4"),
        _createElementVNode("li", {
          class: "keyStyle mx-6",
          "data-key": "5",
          "data-code": "53",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clickNum(5)))
        }, "5"),
        _createElementVNode("li", {
          class: "keyStyle",
          "data-key": "6",
          "data-code": "54",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clickNum(6)))
        }, "6")
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("li", {
          class: "keyStyle",
          "data-key": "7",
          "data-code": "55",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.clickNum(7)))
        }, "7"),
        _createElementVNode("li", {
          class: "keyStyle mx-6",
          "data-key": "8",
          "data-code": "56",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.clickNum(8)))
        }, "8"),
        _createElementVNode("li", {
          class: "keyStyle",
          "data-key": "9",
          "data-code": "57",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.clickNum(9)))
        }, "9")
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("li", {
          class: "keyStyle",
          "data-key": "0",
          "data-code": "110",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clickNum(0)))
        }, " 0"),
        _createElementVNode("li", {
          class: "keyStyle",
          "data-key": "10",
          "data-code": "48",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.add(10)))
        }, "+10"),
        _createElementVNode("li", {
          class: "keyStyle",
          "data-key": "100",
          "data-code": "46",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.add(100)))
        }, "+100")
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("li", {
          class: "keyStyle",
          "data-key": "0",
          "data-code": "48",
          style: {"color":"#606266"},
          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.delte && _ctx.delte(...args)))
        }, [
          _createVNode(_component_JIcon, {
            icon: "mes-delete",
            size: _ctx.$px2rem('48px')
          }, null, 8, ["size"])
        ]),
        _hoisted_11
      ])
    ])
  ]))
}